import React, {useCallback, useRef} from 'react';
import {
  useStreamScreenConnector,
  useStreamStyle,
} from 'api/modules/streamScreen';
import {useParams} from 'react-router';
import styles from './FullScreenMedia.module.css';

type ScreenParams = {
  id: string;
};

const FullscreenMedia: React.FC = () => {
  const {id} = useParams<ScreenParams>();
  const {...mediaData} = useStreamScreenConnector(id);
  const {...styleData} = useStreamStyle();
  const iframeElement = useRef<HTMLIFrameElement>(null);

  const setupStyles = useCallback(
    (style: string) => {
      iframeElement.current?.contentWindow?.postMessage(
        {
          style,
        },
        '*',
      );
    },
    [iframeElement],
  );

  React.useEffect(() => {
    if (
      styleData.data &&
      styleData.data.CurrentStyle &&
      styleData.data.CurrentStyle !== ''
    ) {
      setupStyles(styleData.data.CurrentStyle);
    }
  }, [setupStyles, styleData]);

  if (mediaData.isLoading)
    return (
      <p
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '80px',
        }}
      >
        Загрузка...
      </p>
    );

  if (mediaData.isSuccess && mediaData.data) {
    if (mediaData.data.CurrentMedia && !mediaData.isStale) {
      return (
        <>
          {/* <div className={styles.test} /> */}
          <div className={styles.ocean}>
            <div className={styles.wave} />
            <div className={styles.wave} />
          </div>
          <div className={styles.topPanel} />
          <iframe
            title="Main"
            ref={iframeElement}
            src={mediaData.data.CurrentMedia}
            allow="autoplay;fullscreen;camera;microphone;transparency"
            allowTransparency
            frameBorder={0}
            className={styles.video}
          />
        </>
      );
    }

    return (
      <p
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '80px',
        }}
      >
        {id}
      </p>
    );
  }
  return <p>Произошла ошибка</p>;
};

export default FullscreenMedia;
